import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import { Grid } from "@material-ui/core";

export default function PIPSelections(props) {
    const device = useContext(DeviceContext);
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
        
    const [dataQuotes, setDataQuotes] = React.useState([]);
    const [loadingQuotes, setLoadingQuotes] = React.useState(false);
    const [dataPolicies, setDataPolicies] = React.useState([]);
    const [loadingPolicies, setLoadingPolicies] = React.useState(false);
        
    const GetDataQuotes = async () => {
        const response = await CallAPI("POST", "/Advanced/GetPIPSelectionsQuotes", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });
            
        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                percent.format(row.unlimitedPIP / 100),
                percent.format(row.piP500K / 100),
                percent.format(row.piP250KNoExclusions / 100),
                percent.format(row.piP250KSomeExclusions / 100),
                percent.format(row.piP50K / 100),
                percent.format(row.noPIPMedical / 100),
            ]);
                
            setDataQuotes(formattedResponse);
        } 
            
        setLoadingQuotes(false);
    };

    const GetDataPolicies = async () => {
        const response = await CallAPI("POST", "/Advanced/GetPIPSelectionsPolicies", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });

        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                percent.format(row.unlimitedPIP / 100),
                percent.format(row.piP500K / 100),
                percent.format(row.piP250KNoExclusions / 100),
                percent.format(row.piP250KSomeExclusions / 100),
                percent.format(row.piP50K / 100),
                percent.format(row.noPIPMedical / 100),
            ]);

            setDataPolicies(formattedResponse);
        } 

        setLoadingPolicies(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetDataQuotes();
            setLoadingQuotes(true);
            GetDataPolicies();
            setLoadingPolicies(true);
        }
    }, [props.call]);

    return (
        <Grid container>
            <Grid item lg={6} xs={12}>
                <TableWithContainer
                    title="PIP SELECTIONS - QUOTES"
                    exportName="PIP_Selection_Quotes"
                    loading={loadingQuotes}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={{
                        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                        Table: {
                            Header: { minWidth: "120px" }
                        }
                    }}
                    headers={[[
                        props.groupBy, "Unlimited PIP", "$500K PIP", "	$250K PIP - No Exclusions", "$250K PIP - Some Exclusions", "$50K PIP", "No PIP Medical"
                    ]]}
                    rows={dataQuotes.filter(x => x[0] !== "Total")}
                    footers={dataQuotes.filter(x => x[0] === "Total")}
                />
            </Grid>
            <Grid item lg={6} xs={12}>
                <TableWithContainer
                    title="PIP SELECTIONS - POLICIES"
                    exportName="PIP_Selections_Policies"
                    loading={loadingPolicies}
                    rowsPerPage={32}
                    fixedColumns={1}
                    style={{
                        Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                        Table: {
                            Header: { minWidth: "120px" }
                        }
                    }}
                    headers={[[
                        props.groupBy, "Unlimited PIP", "$500K PIP", "	$250K PIP - No Exclusions", "$250K PIP - Some Exclusions", "$50K PIP", "No PIP Medical"
                    ]]}
                    rows={dataPolicies.filter(x => x[0] !== "Total")}
                    footers={dataPolicies.filter(x => x[0] === "Total")}
                />
            </Grid>
        </Grid>
    );
}
